import mock from '../mock'
import { paginateArray } from '../utils'

const data = [
  {
    id: 1,
    role_name: 'Admin',
    crated_date: '15.04.2021',
    modified_date: '15.04.2021'
  },
  {
    id: 2,
    role_name: 'Web Kontrol Kullanıcı',
    crated_date: '15.04.2021',
    modified_date: '15.04.2021'
  },
  {
    id: 3,
    role_name: 'Bayi Kullanıcı',
    crated_date: '15.04.2021',
    modified_date: '15.04.2021'
  }
]

mock.onGet('/service/api/datatables/initial-data').reply(config => {
  return [200, data]
})

mock.onGet('/service/api/datatables/data').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1 } = config
  /* eslint-enable */

  const queryLowered = q.toLowerCase()
  const filteredData = data.filter(
    item =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      item.full_name.toLowerCase().includes(queryLowered) ||
      item.post.toLowerCase().includes(queryLowered) ||
      item.email.toLowerCase().includes(queryLowered) ||
      item.age.toLowerCase().includes(queryLowered) ||
      item.salary.toLowerCase().includes(queryLowered) ||
      item.start_date.toLowerCase().includes(queryLowered)
  )
  /* eslint-enable  */

  return [
    200,
    {
      allData: data,
      invoices: paginateArray(filteredData, perPage, page),
      total: filteredData.length
    }
  ]
})
